<div class="sub-menu">
  <h1 #sessionLabel class="name" [matTooltip]="chatSessionService.selectedSession()?.label"
    matTooltipPosition="below" [matTooltipDisabled]="!isTextOverflowing">
    {{ chatSessionService.selectedSession()?.label }}
  </h1>
  <div>
    <div class="sensitivity-label">
      @if (slEnabled()) {
        @if (chatSessionService.selectedSession()) {
          @if (chatSessionService.selectedSession()!.sensitivityLabels!.length > 0) {
            <mat-icon class="material-symbols-outlined"
              [style.color]="sensitivityExpanded()?.color || null"
              [fontIcon]="sensitivityExpanded()?.icon ?? 'shield'" />
          }
        }

        <span>{{ sensitivityLabel() }}</span>
      }
    </div>
    <!-- When text is overflowing, show dropdown menu -->
    @if (isTextOverflowing || sidebarState.isOpen()) {
    <button matIconButton [matMenuTriggerFor]="actionMenu" aria-label="Session Actions"
      matTooltip="Session Actions" matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">more_horiz</mat-icon>
    </button>

    <mat-menu #actionMenu="matMenu">
      <button mat-menu-item (click)="openCreateOrEditSessionDialog('create')" aria-label="Create a new session">
        <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true"
          fontIcon="add_circle" />
        <span>Create session</span>
      </button>

      <button mat-menu-item (click)="openClearSessionDialog()"
        [disabled]="(chatSessionService.selectedSession()?.messages!.length === 0) || multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())"
        aria-label="Clear your session">
        <mat-icon class="material-symbols-outlined icon-sm icon-action"
          [ngClass]="{'disabled': (chatSessionService.selectedSession()?.messages!.length === 0 || multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()))}"
          aria-hidden="true" fontIcon="cleaning_services" />
        <span>Clear session</span>
      </button>

      <button mat-menu-item (click)="aiChatService.exportChat()"
        [disabled]="(chatSessionService.selectedSession()?.messages!.length === 0)" aria-label="Export chat">
        <mat-icon class="material-symbols-outlined icon-sm icon-action"
          [ngClass]="{'disabled': (chatSessionService.selectedSession()?.messages!.length === 0)}"
          aria-hidden="true" fontIcon="export_notes" />
        <span>Export chat</span>
      </button>

      <button mat-menu-item (click)="aiChatService.onOpenDocumentManager()" [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())"
        aria-label="Add attachment">
        <mat-icon class="material-symbols-outlined icon-sm icon-action"
          [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()))}" aria-hidden="true" fontIcon="attach_file" />
        <span>Add attachment</span>
      </button>

      <button mat-menu-item (click)="openCreateOrEditSessionDialog('edit')"
        [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())" aria-label="Edit session">
        <mat-icon class="material-symbols-outlined icon-sm icon-action"
          [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()))}" aria-hidden="true" fontIcon="edit" />
        <span>Edit session</span>
      </button>

      <button mat-menu-item (click)="openDeleteSessionDialog()" [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())"
        aria-label="Delete session">
        <mat-icon class="material-symbols-outlined icon-sm icon-action"
          [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()))}" aria-hidden="true"
          fontIcon="delete_forever" />
        <span>Delete session</span>
      </button>

      <button mat-menu-item (click)="openQuickEditSessionDialog()" [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())"
        aria-label="Quick edit agents">
        <mat-icon class="material-symbols-outlined icon-sm icon-action"
          [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()))}" aria-hidden="true"
          fontIcon="app_registration" />
        <span>Quick edit agents</span>
      </button>
      <session-details [isMenuItem]="true" />
    </mat-menu>
    } @else {
    <!-- Regular buttons when not overflowing -->
    <button matIconButton type="button" (click)="openCreateOrEditSessionDialog('create')" #tooltip="matTooltip"
      aria-label="Create a new session" matTooltip="Create a session" matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true" fontIcon="add_circle" />
    </button>

    <button matIconButton type="button" (click)="openClearSessionDialog()"
      [disabled]="(chatSessionService.selectedSession()?.messages!.length === 0) || multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())"
      #tooltip="matTooltip" aria-label="Clear your session" matTooltip="Clear your session"
      matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action"
        [ngClass]="{'disabled': (chatSessionService.selectedSession()?.messages!.length === 0 || multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()))}"
        aria-hidden="true" fontIcon="cleaning_services" />
    </button>

    <button type="button"
      [disabled]="(chatSessionService.selectedSession()?.messages!.length === 0 || automationStateService.isWorkflowInProgress())"
      (click)="aiChatService.exportChat()" matIconButton color="accent" #tooltip="matTooltip" aria-label="Export chat"
      matTooltip="Export chat" matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action"
        [ngClass]="{'disabled': (chatSessionService.selectedSession()?.messages!.length === 0 || automationStateService.isWorkflowInProgress())}"
        aria-hidden="true" fontIcon="export_notes" />
    </button>

    <button type="button" (click)="aiChatService.onOpenDocumentManager()" matIconButton #tooltip="matTooltip"
      aria-label="Add attachment" matTooltip="Add attachment" matTooltipPosition="below"
      [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId())">
      <mat-icon class="material-symbols-outlined icon-sm icon-action"
        [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress())}"
        aria-hidden="true" fontIcon="attach_file" />
    </button>

    <button matIconButton type="button" (click)="openCreateOrEditSessionDialog('edit')" #tooltip="matTooltip"
      aria-label="Edit session" matTooltip="Edit session" matTooltipPosition="below"
      [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress()">
      <mat-icon class="material-symbols-outlined icon-sm icon-action"
        [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress())}"
        aria-hidden="true" fontIcon="edit" />
    </button>

    <button matIconButton type="button" (click)="openQuickEditSessionDialog()" #tooltip="matTooltip"
      aria-label="Quick edit agents" matTooltip="Quick edit agents" matTooltipPosition="below"
      [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress()">
      <mat-icon class="material-symbols-outlined icon-sm icon-action"
        [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress())}"
        aria-hidden="true" fontIcon="app_registration" />
    </button>

    <button matIconButton type="button" (click)="openDeleteSessionDialog()" #tooltip="matTooltip"
      aria-label="Delete session" matTooltip="Delete session" matTooltipPosition="below"
      [disabled]="multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress()">
      <mat-icon class="material-symbols-outlined icon-sm icon-action"
        [ngClass]="{'disabled': (multiSessionService.isSessionStreaming(chatSessionService.selectedSessionId()) || automationStateService.isWorkflowInProgress())}"
        aria-hidden="true" fontIcon="delete_forever" />
    </button>

    <session-details />
    }

    <!-- Always show the Automation Library button -->
    <button matIconButton type="button" (click)="toggleSidebar()" #tooltip="matTooltip"
      aria-label="Toggle Automation Library" matTooltip="Automation Library" matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true"
        [fontIcon]="sidebarState.isOpen() ? 'right_panel_close' : 'right_panel_open'" />
    </button>
  </div>
</div>
<div class="chat-container">
  <div #chatContent class="chat-content">
    @if (chatSessionService.selectedSession()?.id) {
    <chat-message-view></chat-message-view>
    } @else {
    @defer (when initializationService.initializationComplete()) {
    <div class="no-session">
      <div>
        <p>Welcome to CGI Federal AI Assist. Please use responsibly.</p>
        @if (showNoSessionExistMessage()) {
        <p>The session requested could not be found.</p>
        <p>Please click on the "Create Session" button below to create a new Session or select another one.</p>
        } @else {
        <p>There are currently no sessions created.</p>
        <p>Please click on the "Create Session" button below to create a new Session.</p>
        }
      </div>

      <button matButton (click)="openCreateOrEditSessionDialog('create')">Create Session</button>
    </div>
    }
    }
  </div>

  <div class="chat-footer">
    <app-ai-chat-prompt
    [promptText]="promptText"
    [promptAttachedDocuments]="chatDocumentService.selectedDocuments()"
    (promptSubmitted)="onPromptSubmitted()"></app-ai-chat-prompt>
  </div>
</div>
